import { ExternalAfterFixProofClientSafeSummaryV1Schema, } from "../contracts/external-after-fix-proof.js";
const STATUS_LABELS = {
    FIXED: "Looks improved on re-scan",
    STILL_OPEN: "Still open on re-scan",
    NEEDS_PROOF: "Needs proof",
    NOT_CHECKED: "Not checked on re-scan",
    CHANGED_BUT_UNVERIFIED: "Changed — needs verification",
};
/** Strip internal provenance for client portal / client link rendering. */
export function sanitizeClientSafeExternalAfterFixProof(proof) {
    const allRows = [...proof.actionItemsCompared];
    const visibleRows = allRows.filter((row) => row.status === "FIXED" ||
        row.status === "STILL_OPEN" ||
        row.status === "NEEDS_PROOF" ||
        row.status === "CHANGED_BUT_UNVERIFIED");
    const summaryCounts = {
        fixed: visibleRows.filter((row) => row.status === "FIXED").length,
        stillOpen: visibleRows.filter((row) => row.status === "STILL_OPEN").length,
        needsProof: visibleRows.filter((row) => row.status === "NEEDS_PROOF" || row.status === "CHANGED_BUT_UNVERIFIED").length,
    };
    const headline = summaryCounts.fixed > 0
        ? "Some recommended fixes show improved scan signals after your agency's external updates."
        : "Follow-up scan completed — review items that still need attention or proof.";
    return ExternalAfterFixProofClientSafeSummaryV1Schema.parse({
        schemaId: "externalAfterFixProof.clientSafeSummary.v1",
        afterFixProofId: proof.afterFixProofId,
        projectId: proof.projectId,
        lifecycleStatus: "READY_CLIENT_SAFE_SUMMARY",
        headline,
        summaryCounts,
        items: visibleRows.slice(0, 20).map((row) => ({
            label: row.issueSummary,
            status: row.status,
            summary: row.status === "FIXED"
                ? "Re-scan signal improved for this item."
                : row.status === "STILL_OPEN"
                    ? "This item still appears open on the follow-up scan."
                    : "This item still needs agency or client proof beyond scan signals alone.",
        })),
        whatWeDoNotPromise: proof.whatWeDoNotPromise,
        comparedAt: proof.comparedAt,
        generatedAt: proof.generatedAt,
        clientSafe: true,
    });
}
/** Leak scan — client-safe after-fix proof must not contain internal id patterns. */
export function clientSafeExternalAfterFixProofLeakCheck(view) {
    const leaks = [];
    const blob = JSON.stringify(view);
    const forbidden = [
        /snapshot_/,
        /scan_/,
        /fkit_ext_/,
        /rpt_ext_/,
        /erfind_/,
        /sourceRef/,
        /sourceFindingId/,
        /priorCheckStatus/,
        /newCheckStatus/,
        /checkId/,
        /traceId/,
        /htmlByteLength/,
        /worker/,
        /normalizedUrl/,
        /publicReportRef/,
    ];
    for (const pattern of forbidden) {
        if (pattern.test(blob))
            leaks.push(pattern.source);
    }
    return leaks;
}
export { STATUS_LABELS as EXTERNAL_AFTER_FIX_STATUS_LABELS };
//# sourceMappingURL=sanitize-client-safe-external-after-fix-proof.js.map